export default __webpack_public_path__ + "img/eDEvJrhE.61599d03.svg";